import { styled } from "../../../styled-components";

export const SearchBarContainerStyle = styled.div`
    ${p => p.theme.searchBar.style === "Collapsed" && `flex-grow: 1`};
    padding: ${p =>
        p.theme.searchBar.style === "Collapsed"
            ? `0 0 0 ${p.theme.pageMarginMedium}px`
            : `0 ${p.theme.pageMarginMedium}px ${p.theme.pageMarginMedium}px`};

    display: flex;
    justify-content: center;
`;

// export const SearchIcon = () => (
//     <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M5.94286 0C9.22514 0 11.8857 2.66057 11.8857 5.94286C11.8857 7.41486 11.3463 8.768 10.4594 9.81029L10.7063 10.0571H11.4286L16 14.6286L14.6286 16L10.0571 11.4286V10.7063L9.81029 10.4594C8.768 11.3463 7.41486 11.8857 5.94286 11.8857C2.66057 11.8857 0 9.22514 0 5.94286C0 2.66057 2.66057 0 5.94286 0ZM5.94286 1.82857C3.65714 1.82857 1.82857 3.65714 1.82857 5.94286C1.82857 8.22857 3.65714 10.0571 5.94286 10.0571C8.22857 10.0571 10.0571 8.22857 10.0571 5.94286C10.0571 3.65714 8.22857 1.82857 5.94286 1.82857Z" />
//     </svg>
// );

export const SearchIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.29248 14.8877C9.67871 14.8877 10.957 14.4395 12.0029 13.6924L15.9375 17.627C16.1201 17.8096 16.3608 17.9009 16.6182 17.9009C17.1577 17.9009 17.5396 17.4858 17.5396 16.9546C17.5396 16.7056 17.4565 16.4648 17.2739 16.2905L13.3643 12.3726C14.186 11.2935 14.6758 9.95703 14.6758 8.50439C14.6758 4.99316 11.8037 2.12109 8.29248 2.12109C4.78955 2.12109 1.90918 4.98486 1.90918 8.50439C1.90918 12.0156 4.78125 14.8877 8.29248 14.8877ZM8.29248 13.5098C5.55322 13.5098 3.28711 11.2437 3.28711 8.50439C3.28711 5.76514 5.55322 3.49902 8.29248 3.49902C11.0317 3.49902 13.2979 5.76514 13.2979 8.50439C13.2979 11.2437 11.0317 13.5098 8.29248 13.5098Z" />
    </svg>
);

export const SearchBarStyle = styled.div`
    color: ${p => p.theme.searchBar.textColor};
    height: ${p => p.theme.searchBar.height}px;
    padding: 0 ${p => p.theme.searchBar.paddingSides}px;
    border-radius: 10px;
    background-color: ${p => p.theme.searchBar.backgroundColor};
    display: flex;
    align-items: center;

    width: 100%;
    max-width: ${p => p.theme.searchBar.maxWidth};

    svg {
        fill: ${p => p.theme.searchBar.textColor};
    }
`;

export const SearchBarInputStyle = styled.input`
    border: 0;

    ${p => p.theme.fontStyles.Body4};
    ::placeholder {
        color: ${p => p.theme.searchBar.placeholderColor};
    }

    color: ${p => p.theme.searchBar.textColor};
    background-color: transparent;
    flex-grow: 1;
    margin-left: ${p => p.theme.searchBar.iconPadding}px;
    &:focus {
        outline: none;
    }
`;

export const CloseButtonWrapper = styled.div`
    width: 36px;
    height: 36px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: -12px;
    &:hover {
        cursor: pointer;
    }
`;
